import {
  mapState,
  mapActions,
} from 'vuex';

export default {

  data() {
    return {
      adminSchemaLoaded: false,
    };
  },

  computed: {
    ...mapState({
      fetcherAdminSchemas: state => state.fetcherAdminSchemas.fetcherAdminSchemas,
    }),
  },

  methods: {
    ...mapActions(['getFetcherAdminSchema']),

    async loadFetcherAdminSchema(schema) {
      if (this.debug) { console.log(`${schema} schema requested!`); }
      if (Object.keys(this.fetcherAdminSchemas[schema]).length === 0) {
        try {
          if (this.debug) { console.log(`fetching ${schema} schema...`); }
          await this.getFetcherAdminSchema({
            params: {
              schema,
            },
          });

          if (this.debug) { console.log(`${schema} fetched!`); }

          this.adminSchemaLoaded = true;
          Bus.$emit('fetcher_admin_schema_loaded');
        } catch (error) {
          if (this.debug) { console.log(error); }
        }
      } else if (this.debug) {
        console.log(`${schema} schema already fetched!`);

        this.adminSchemaLoaded = true;
        Bus.$emit('fetcher_admin_schema_loaded');
      }
    },
  },

  mounted() {
    Bus.$on('fetcher_admin_schema_loaded', () => {
      if (this.debug) { console.log('schemas-loader.fetcherAdminSchemas', this.fetcherAdminSchemas); }
    });

    Bus.$on('refresh_admin_schema', (schema) => {
      this.loadFetcherAdminSchema(schema);
    });

    Bus.$on('refresh_admin_schemas', () => {
      this.loadFetcherAdminSchema('forms');
    });
  },

  beforeDestroy() {
    Bus.$off('fetcher_admin_schema_loaded');
    Bus.$off('refresh_admin_schema');
    Bus.$off('refresh_admin_schemas');
  },
};
